

export const frontMatter = {
	sidebar_position: 90
};
export const contentTitle = 'Solidity';
export const metadata = {
  "id": "Features/Regions of interest/Solidity",
  "title": "Solidity",
  "description": "Measure of the compactness of a region or object.",
  "source": "@site/docs/Features/Regions of interest/Solidity.md",
  "sourceDirName": "Features/Regions of interest",
  "slug": "/Features/Regions of interest/Solidity",
  "permalink": "/docs/Features/Regions of interest/Solidity",
  "draft": false,
  "unlisted": false,
  "editUrl": "https://github.com/image-js/image-js-docs/tree/main/docs/Features/Regions of interest/Solidity.md",
  "tags": [],
  "version": "current",
  "sidebarPosition": 90,
  "frontMatter": {
    "sidebar_position": 90
  },
  "sidebar": "tutorialSidebar",
  "previous": {
    "title": "Holes info",
    "permalink": "/docs/Features/Regions of interest/Holes info"
  },
  "next": {
    "title": "Roundness",
    "permalink": "/docs/Features/Regions of interest/Roundness"
  }
};
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    annotation: "annotation",
    br: "br",
    code: "code",
    em: "em",
    h1: "h1",
    math: "math",
    mfrac: "mfrac",
    mi: "mi",
    mo: "mo",
    mrow: "mrow",
    p: "p",
    pre: "pre",
    semantics: "semantics",
    span: "span",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      id: "solidity",
      children: "Solidity"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.em, {
        children: "Measure of the compactness of a region or object."
      })
    }), "\n", _jsx(_components.p, {
      children: _jsxs(_components.a, {
        href: "https://image-js.github.io/image-js-typescript/classes/Roi.html#solidity",
        title: "github.io link",
        children: ["🔎 ROI options and parameters of ", _jsx(_components.code, {
          children: "solidity"
        }), " accessor"]
      })
    }), "\n", _jsx(_components.p, {
      children: "The solidity describes the extent to which a shape is convex or concave.\nIt is calculated through this formula."
    }), "\n", _jsx(_components.span, {
      className: "katex-display",
      children: _jsxs(_components.span, {
        className: "katex",
        children: [_jsx(_components.span, {
          className: "katex-mathml",
          children: _jsx(_components.math, {
            xmlns: "http://www.w3.org/1998/Math/MathML",
            display: "block",
            children: _jsxs(_components.semantics, {
              children: [_jsxs(_components.mrow, {
                children: [_jsx(_components.mi, {
                  children: "S"
                }), _jsx(_components.mi, {
                  children: "o"
                }), _jsx(_components.mi, {
                  children: "l"
                }), _jsx(_components.mi, {
                  children: "i"
                }), _jsx(_components.mi, {
                  children: "d"
                }), _jsx(_components.mi, {
                  children: "i"
                }), _jsx(_components.mi, {
                  children: "t"
                }), _jsx(_components.mi, {
                  children: "y"
                }), _jsx(_components.mo, {
                  children: "="
                }), _jsxs(_components.mfrac, {
                  children: [_jsxs(_components.mrow, {
                    children: [_jsx(_components.mi, {
                      children: "S"
                    }), _jsx(_components.mi, {
                      children: "u"
                    }), _jsx(_components.mi, {
                      children: "r"
                    }), _jsx(_components.mi, {
                      children: "f"
                    }), _jsx(_components.mi, {
                      children: "a"
                    }), _jsx(_components.mi, {
                      children: "c"
                    }), _jsx(_components.mi, {
                      children: "e"
                    })]
                  }), _jsxs(_components.mrow, {
                    children: [_jsx(_components.mi, {
                      children: "C"
                    }), _jsx(_components.mi, {
                      children: "o"
                    }), _jsx(_components.mi, {
                      children: "n"
                    }), _jsx(_components.mi, {
                      children: "v"
                    }), _jsx(_components.mi, {
                      children: "e"
                    }), _jsx(_components.mi, {
                      children: "x"
                    }), _jsx(_components.mi, {
                      children: "H"
                    }), _jsx(_components.mi, {
                      children: "u"
                    }), _jsx(_components.mi, {
                      children: "l"
                    }), _jsx(_components.mi, {
                      children: "l"
                    }), _jsx(_components.mi, {
                      mathvariant: "normal",
                      children: "."
                    }), _jsx(_components.mi, {
                      children: "s"
                    }), _jsx(_components.mi, {
                      children: "u"
                    }), _jsx(_components.mi, {
                      children: "r"
                    }), _jsx(_components.mi, {
                      children: "f"
                    }), _jsx(_components.mi, {
                      children: "a"
                    }), _jsx(_components.mi, {
                      children: "c"
                    }), _jsx(_components.mi, {
                      children: "e"
                    })]
                  })]
                }), _jsx(_components.mo, {
                  separator: "true",
                  children: ";"
                })]
              }), _jsx(_components.annotation, {
                encoding: "application/x-tex",
                children: "Solidity = \\frac{Surface}{ConvexHull.surface};"
              })]
            })
          })
        }), _jsxs(_components.span, {
          className: "katex-html",
          "aria-hidden": "true",
          children: [_jsxs(_components.span, {
            className: "base",
            children: [_jsx(_components.span, {
              className: "strut",
              style: {
                height: "0.8889em",
                verticalAlign: "-0.1944em"
              }
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              style: {
                marginRight: "0.05764em"
              },
              children: "S"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "o"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              style: {
                marginRight: "0.01968em"
              },
              children: "l"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "i"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "d"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "i"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "t"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              style: {
                marginRight: "0.03588em"
              },
              children: "y"
            }), _jsx(_components.span, {
              className: "mspace",
              style: {
                marginRight: "0.2778em"
              }
            }), _jsx(_components.span, {
              className: "mrel",
              children: "="
            }), _jsx(_components.span, {
              className: "mspace",
              style: {
                marginRight: "0.2778em"
              }
            })]
          }), _jsxs(_components.span, {
            className: "base",
            children: [_jsx(_components.span, {
              className: "strut",
              style: {
                height: "2.2519em",
                verticalAlign: "-0.8804em"
              }
            }), _jsxs(_components.span, {
              className: "mord",
              children: [_jsx(_components.span, {
                className: "mopen nulldelimiter"
              }), _jsx(_components.span, {
                className: "mfrac",
                children: _jsxs(_components.span, {
                  className: "vlist-t vlist-t2",
                  children: [_jsxs(_components.span, {
                    className: "vlist-r",
                    children: [_jsxs(_components.span, {
                      className: "vlist",
                      style: {
                        height: "1.3714em"
                      },
                      children: [_jsxs(_components.span, {
                        style: {
                          top: "-2.314em"
                        },
                        children: [_jsx(_components.span, {
                          className: "pstrut",
                          style: {
                            height: "3em"
                          }
                        }), _jsxs(_components.span, {
                          className: "mord",
                          children: [_jsx(_components.span, {
                            className: "mord mathnormal",
                            style: {
                              marginRight: "0.07153em"
                            },
                            children: "C"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            children: "o"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            children: "n"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            style: {
                              marginRight: "0.03588em"
                            },
                            children: "v"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            children: "e"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            children: "x"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            style: {
                              marginRight: "0.08125em"
                            },
                            children: "H"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            children: "u"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            style: {
                              marginRight: "0.01968em"
                            },
                            children: "ll"
                          }), _jsx(_components.span, {
                            className: "mord",
                            children: "."
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            children: "s"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            children: "u"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            style: {
                              marginRight: "0.02778em"
                            },
                            children: "r"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            style: {
                              marginRight: "0.10764em"
                            },
                            children: "f"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            children: "a"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            children: "ce"
                          })]
                        })]
                      }), _jsxs(_components.span, {
                        style: {
                          top: "-3.23em"
                        },
                        children: [_jsx(_components.span, {
                          className: "pstrut",
                          style: {
                            height: "3em"
                          }
                        }), _jsx(_components.span, {
                          className: "frac-line",
                          style: {
                            borderBottomWidth: "0.04em"
                          }
                        })]
                      }), _jsxs(_components.span, {
                        style: {
                          top: "-3.677em"
                        },
                        children: [_jsx(_components.span, {
                          className: "pstrut",
                          style: {
                            height: "3em"
                          }
                        }), _jsxs(_components.span, {
                          className: "mord",
                          children: [_jsx(_components.span, {
                            className: "mord mathnormal",
                            style: {
                              marginRight: "0.05764em"
                            },
                            children: "S"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            children: "u"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            style: {
                              marginRight: "0.02778em"
                            },
                            children: "r"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            style: {
                              marginRight: "0.10764em"
                            },
                            children: "f"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            children: "a"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            children: "ce"
                          })]
                        })]
                      })]
                    }), _jsx(_components.span, {
                      className: "vlist-s",
                      children: "​"
                    })]
                  }), _jsx(_components.span, {
                    className: "vlist-r",
                    children: _jsx(_components.span, {
                      className: "vlist",
                      style: {
                        height: "0.8804em"
                      },
                      children: _jsx(_components.span, {})
                    })
                  })]
                })
              }), _jsx(_components.span, {
                className: "mclose nulldelimiter"
              })]
            }), _jsx(_components.span, {
              className: "mpunct",
              children: ";"
            })]
          })]
        })]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Where ", _jsxs(_components.span, {
        className: "katex",
        children: [_jsx(_components.span, {
          className: "katex-mathml",
          children: _jsx(_components.math, {
            xmlns: "http://www.w3.org/1998/Math/MathML",
            children: _jsxs(_components.semantics, {
              children: [_jsxs(_components.mrow, {
                children: [_jsx(_components.mi, {
                  children: "C"
                }), _jsx(_components.mi, {
                  children: "o"
                }), _jsx(_components.mi, {
                  children: "n"
                }), _jsx(_components.mi, {
                  children: "v"
                }), _jsx(_components.mi, {
                  children: "e"
                }), _jsx(_components.mi, {
                  children: "x"
                }), _jsx(_components.mi, {
                  children: "H"
                }), _jsx(_components.mi, {
                  children: "u"
                }), _jsx(_components.mi, {
                  children: "l"
                }), _jsx(_components.mi, {
                  children: "l"
                }), _jsx(_components.mi, {
                  mathvariant: "normal",
                  children: "."
                }), _jsx(_components.mi, {
                  children: "s"
                }), _jsx(_components.mi, {
                  children: "u"
                }), _jsx(_components.mi, {
                  children: "r"
                }), _jsx(_components.mi, {
                  children: "f"
                }), _jsx(_components.mi, {
                  children: "a"
                }), _jsx(_components.mi, {
                  children: "c"
                }), _jsx(_components.mi, {
                  children: "e"
                })]
              }), _jsx(_components.annotation, {
                encoding: "application/x-tex",
                children: "ConvexHull.surface"
              })]
            })
          })
        }), _jsx(_components.span, {
          className: "katex-html",
          "aria-hidden": "true",
          children: _jsxs(_components.span, {
            className: "base",
            children: [_jsx(_components.span, {
              className: "strut",
              style: {
                height: "0.8889em",
                verticalAlign: "-0.1944em"
              }
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              style: {
                marginRight: "0.07153em"
              },
              children: "C"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "o"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "n"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              style: {
                marginRight: "0.03588em"
              },
              children: "v"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "e"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "x"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              style: {
                marginRight: "0.08125em"
              },
              children: "H"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "u"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              style: {
                marginRight: "0.01968em"
              },
              children: "ll"
            }), _jsx(_components.span, {
              className: "mord",
              children: "."
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "s"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "u"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              style: {
                marginRight: "0.02778em"
              },
              children: "r"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              style: {
                marginRight: "0.10764em"
              },
              children: "f"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "a"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "ce"
            })]
          })
        })]
      }), " is the surface of ROIs convex hull."]
    }), "\n", _jsxs(_components.p, {
      children: ["It provides insights into the shape irregularity and concavity of the structure.", _jsx(_components.br, {}), "\n", "The solidity of a completely convex shape is 1, the farther it deviates from 1, the greater the extent of concavity in the shape of the ROI."]
    }), "\n", _jsx(_components.p, {
      children: "In ImageJS solidity is a ROI class accessor that returns a solidity index:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-ts",
        children: "const solidity = roi.solidity;\n"
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

